(function () {

    'use strict';

    // NOTE we do this to maintain the illusion of the module pattern since we
    // have to load this file on the server as well.
    const definition = function (App) {

        const sortFunctions = App.sortFunctions = {};

        sortFunctions.numericValueSort = function (valueFunction) {
            return function (a, b, order) {
                let value;

                const aVal = valueFunction(a);
                const bVal = valueFunction(b);

                const aIsNaN = isNaN(aVal);
                const bIsNaN = isNaN(bVal);

                if (aIsNaN && bIsNaN) {
                    value = 0;
                } else if (aIsNaN && !bIsNaN) {
                    value = 1;
                } else if (bIsNaN) {
                    value = -1;
                } else {
                    value = bVal - aVal;
                }

                return order * value;
            };
        };
    };

    let App;

    if (typeof window === 'undefined') {

        App = {};
    } else {

        App = window.RivalIQ;
    }

    definition(App);

    if (typeof window === 'undefined') {

        module.exports = App.sortFunctions;
    }

}());
